module.exports = __webpack_public_path__ + "img/20211017_092821.e95d57e8.jpg";